
import React from "react";

// reactstrap components
import { Container, Row, Col } from "reactstrap";

// core components

function SectionChronology2020() {
  return (
    <>
      <div className="section section-dark gradient-background-claro" style={{ paddingBotom: "0px" }} >

        <Container className="tim-container">

          <div className="title">
            <h3>2020</h3>
          </div>

          <div id="typography">
            <Row>

              <div className="typography-line">
                <p>
                  <span className="note" style={{ top: "4px" }} > July 4th </span>
                  All chars completed (45 in total), but not optimized.
                  Up to this point, with the new tools learned in image editing and palettes, the final weight of the remastered chars was drastically reduced,
                  but it was decided to continue testing ways to further optimize the new sprites.
                </p>
                <Row style={{ width: "100%", marginTop: "20px" }}>
                  <Col xs="12" sm="6">
                    <img
                      width="100%"
                      alt="..."
                      src={require("assets/img/Development/Pre-Optim.jpg")}
                    />
                  </Col>
                </Row>
              </div>

              <div className="typography-line">
                <p>
                  <span className="note" style={{ top: "4px" }} > August 8th </span>
                  End of chars sprite remastering. At this point all chars were optimized, screen loads on 7200rpm HDDs took less than 3 seconds.
                  The game opened faster than before and the character sprites had lost almost nothing in quality.
                </p>
                <Row style={{ width: "100%", marginTop: "20px" }}>
                  <Col xs="12" sm="6">
                    <img
                      width="100%"
                      alt="..."
                      src={require("assets/img/Development/Post-Optim.jpg")}
                    />
                  </Col>
                </Row>
              </div>

            </Row>
          </div>

        </Container>
      </div>
    </>
  );
}

export default SectionChronology2020;
